import React, { Component } from 'react'

export default class Volunteer extends Component {
    render() {
        return (
            <>
                <div id="page-4" className="page four">
                    <h2 className="heading">Volunteer</h2>
                    <div className="resume-wrap d-flex ftco-animate">
                        <div className="icon d-flex align-items-center justify-content-center">
                            <span className="flaticon-ideas"></span>
                        </div>
                        <div className="text pl-3">
                            <span className="date">Dec 2016 – 2018</span>
                            <h2>Fanshawe Information Technology Ambassador</h2>
                            <span className="position">Fanshawe College, London, Ontario</span>
                            <p>Demonstrating and teaching early programming concepts and fundamentals to ESL
students who are unfamiliar with coding</p>
                        </div>
                    </div>
                    <div className="resume-wrap d-flex ftco-animate">
                        <div className="icon d-flex align-items-center justify-content-center">
                            <span className="flaticon-ideas"></span>
                        </div>
                        <div className="text pl-3">
                            <span className="date">Aug 2014 – Nov 2014</span>
                            <h2>Tutor and Volunteer</h2>
                            <span className="position">Kutumb NGO, Kutumb, India</span>
                            <p>Providing assistance to local elementary schools with cooking, cleaning, and preparing relevant curriculum</p>
                            <p>Teaching Korean culture and language to students and locals of the villages</p>
                        </div>
                    </div>

                </div>
            </>
        )
    }
}
